import { combineReducers } from 'redux';
import { eventsDuck } from '@eb/redux-destination';
import upcomingEventsReducer from './upcoming';

import { SET_UPCOMING_EVENTS, EVENTS_LOADING } from '../../actions/events';

const isLoading = (state = false, { type, payload }) => {
    let nextState = state;

    if (type === EVENTS_LOADING) {
        nextState = payload;
    } else if (type === SET_UPCOMING_EVENTS) {
        nextState = false;
    }

    return nextState;
};

export default combineReducers({
    isLoading,
    entities: eventsDuck.reducer,
    upcoming: upcomingEventsReducer,
});
